function ProgressBarInactiveIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="27" height="27" rx="13.5" fill="#F6F6F6" />
      <rect x="0.5" y="0.5" width="27" height="27" rx="13.5" stroke="#E8E8E9" />
      <circle cx="14" cy="14" r="6" fill="#1D1B20" fillOpacity="0.1" />
    </svg>
  );
}

export default ProgressBarInactiveIcon;
